import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import HomePage from '../screens/Dashboard/HomePage';
import BookDetailScreen from '../screens/Book/BookDetailScreen';
import InsightDetailScreen from '../screens/Book/InsightDetailScreen';
import IntroductionScreen from '../screens/Book/IntroductionScreen';
import BookReaderScreen from '../screens/Book/BookReaderScreen';
import MentorChatScreen from '../screens/MentorChat/MentorChatScreen';
import CollectionDetailScreen from '../screens/Collection/CollectionDetailScreen';
import GuruDetailScreen from '../screens/shared/components/GuruDetailScreen';
import CategoryScreen from '../screens/Explore/CategoryScreen';
import ArticleDetailScreen from '../screens/Dashboard/ArticleDetailScreen';
import RecommendedBooksScreen from '../screens/Dashboard/RecommendedBooksScreen';
import MyReadingListScreen from '../screens/Dashboard/MyReadingListScreen';
import { Colors } from '../utils/theme';
import { FireInsight } from '../models/FirestoreModels';

export type DashboardStackParamList = {
  Dashboard: undefined;
  MentorChat: {
    initialMessage?: string;
    autoSend?: boolean;
  };
  ArticleDetail: {
    articleId: string;
  };
  Category: {
    categoryId: string;
    categoryName: string;
  };
  BookDetail: { 
    bookId: string; 
    languageCode?: string;
    // Don't pass recommendationReason - load from DB
  };
  InsightDetail: { 
    insights: FireInsight[];
    book?: any;
    bookTitle?: string;
    bookCoverUrl?: string;
    currentIndex: number;
    isMixedInsights?: boolean;
    // Don't pass recommendationReason - load from DB
  };
  BookReader: {
    // Option 1: Book mode
    bookId?: string;
    languageCode?: string;
    includeIntroduction?: boolean;
    // Option 2: Collection mode
    insightIds?: string[];
    // Navigation
    currentIndex?: number;
    fromRoute?: string;
  };
  Introduction: {
    bookId: string;
    languageCode?: string;
  };
  CollectionDetail: {
    collectionId: string;
    collectionTitle: string;
    collectionIcon?: string;
    bookIds: string[];
  };
  GuruDetail: {
    guruId: string;
    guruName: string;
    guruImage: any;
    bookIds: string[];
  };
  RecommendedBooks: undefined;
  MyReadingList: undefined;
  ChapterReader: { bookId: string; chapterId: string; chapterIndex: number };
  AudiobookPlayer: { bookId: string };
  Actions: { bookId: string };
};

const Stack = createStackNavigator<DashboardStackParamList>();

const DashboardStackNavigator = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerStyle: {
          backgroundColor: Colors.background,
          elevation: 0,
          shadowOpacity: 0,
        },
        headerTintColor: Colors.textPrimary,
        headerTitleStyle: {
          fontWeight: '600',
        },
      }}
    >
      <Stack.Screen 
        name="Dashboard" 
        component={HomePage}
        options={{ 
          title: 'Dashboard',
          headerShown: false 
        }} 
      />
      <Stack.Screen 
        name="MentorChat" 
        component={MentorChatScreen}
        options={{ 
          title: 'Chat with Mentor',
          headerShown: false 
        }} 
      />
      <Stack.Screen 
        name="ArticleDetail" 
        component={ArticleDetailScreen}
        options={{ 
          title: 'Article',
          headerShown: false 
        }} 
      />
      <Stack.Screen 
        name="Category" 
        component={CategoryScreen}
        options={{ 
          headerShown: false,
        }} 
      />
      <Stack.Screen 
        name="BookDetail" 
        component={BookDetailScreen}
        options={{ 
          title: 'Book Details',
          headerBackTitle: 'Back',
          headerShown: false,
        }} 
      />
      <Stack.Screen 
        name="InsightDetail" 
        component={InsightDetailScreen}
        options={{ 
          headerShown: false,
          presentation: 'modal',
          cardStyle: { backgroundColor: 'transparent' },
          animationEnabled: true,
        }} 
      />
      <Stack.Screen 
        name="Introduction" 
        component={IntroductionScreen}
        options={{ 
          headerShown: false,
          presentation: 'modal',
          cardStyle: { backgroundColor: 'transparent' },
          animationEnabled: true,
        }} 
      />
      <Stack.Screen 
        name="BookReader" 
        component={BookReaderScreen}
        options={{ 
          headerShown: false,
          presentation: 'modal',
          cardStyle: { backgroundColor: 'transparent' },
          animationEnabled: true,
        }} 
      />
      <Stack.Screen 
        name="CollectionDetail" 
        component={CollectionDetailScreen}
        options={{ 
          headerShown: false,
        }} 
      />
      <Stack.Screen 
        name="GuruDetail" 
        component={GuruDetailScreen}
        options={{ 
          headerShown: false,
        }} 
      />
      <Stack.Screen 
        name="RecommendedBooks" 
        component={RecommendedBooksScreen}
        options={{ 
          headerShown: false,
        }} 
      />
      <Stack.Screen 
        name="MyReadingList" 
        component={MyReadingListScreen}
        options={{ 
          headerShown: false,
        }} 
      />
      {/* Placeholder screens - to be implemented */}
      {/* <Stack.Screen 
        name="ChapterReader" 
        component={ChapterReaderScreen}
        options={{ 
          title: 'Chapter',
        }} 
      />
      <Stack.Screen 
        name="AudiobookPlayer" 
        component={AudiobookPlayerScreen}
        options={{ 
          title: 'Audiobook',
        }} 
      />
      <Stack.Screen 
        name="Actions" 
        component={ActionsScreen}
        options={{ 
          title: 'Actions',
        }} 
      /> */}
    </Stack.Navigator>
  );
};

export default DashboardStackNavigator; 